export const NIKKECharacterRatings = [
  {
    Name: '2B',
    Story_LD: 'C',
    Story_HD: 'C',
    Boss: 'A',
    PVP: 'A',
    Rarity: 'SSR',
    Burst_Type: 'III',
    Class: 'Defender',
    Element: 'Fire',
    Weapon: 'AR',
    Manufacturer: 'Abnormal',
    New: 'No',
    Limited: 'Yes',
    Investment: 'Yes',
    Treasure: 'No',
    ID: 1,
    Slug: '2b'
  },
  {
    Name: 'A2',
    Story_LD: 'A',
    Story_HD: 'A',
    Boss: 'A',
    PVP: 'A',
    Rarity: 'SSR',
    Burst_Type: 'III',
    Class: 'Attacker',
    Element: 'Fire',
    Weapon: 'RL',
    Manufacturer: 'Abnormal',
    New: 'No',
    Limited: 'Yes',
    Investment: 'No',
    Treasure: 'No',
    ID: 2,
    Slug: 'a2'
  },
  {
    Name: 'Ade',
    Story_LD: 'C',
    Story_HD: 'C',
    Boss: 'C',
    PVP: 'D',
    Rarity: 'SSR',
    Burst_Type: 'II',
    Class: 'Supporter',
    Element: 'Wind',
    Weapon: 'AR',
    Manufacturer: 'Tetra',
    New: 'No',
    Limited: 'No',
    Investment: 'No',
    Treasure: 'No',
    ID: 3,
    Slug: 'ade'
  },
  {
    Name: 'Admi',
    Story_LD: 'B',
    Story_HD: 'C',
    Boss: 'C',
    PVP: 'E',
    Rarity: 'SSR',
    Burst_Type: 'II',
    Class: 'Supporter',
    Element: 'Wind',
    Weapon: 'SR',
    Manufacturer: 'Missilis',
    New: 'No',
    Limited: 'No',
    Investment: 'No',
    Treasure: 'No',
    ID: 4,
    Slug: 'admi'
  },
  {
    Name: 'Alice',
    Story_LD: 'SS',
    Story_HD: 'SSS',
    Boss: 'SSS',
    PVP: 'A',
    Rarity: 'SSR',
    Burst_Type: 'III',
    Class: 'Attacker',
    Element: 'Fire',
    Weapon: 'SR',
    Manufacturer: 'Tetra',
    New: 'No',
    Limited: 'No',
    Investment: 'Yes',
    Treasure: 'No',
    ID: 5,
    Slug: 'alice'
  },
  {
    Name: 'Alice: Wonderland Bunny',
    Story_LD: 'A',
    Story_HD: 'A',
    Boss: 'A',
    PVP: 'D',
    Rarity: 'SSR',
    Burst_Type: 'I',
    Class: 'Supporter',
    Element: 'Water',
    Weapon: 'SMG',
    Manufacturer: 'Tetra',
    New: 'No',
    Limited: 'No',
    Investment: 'No',
    Treasure: 'No',
    ID: 6,
    Slug: 'alice-wonderland-bunny'
  },
  {
    Name: 'Anchor',
    Story_LD: 'E',
    Story_HD: 'E',
    Boss: 'E',
    PVP: 'D',
    Rarity: 'SR',
    Burst_Type: 'I',
    Class: 'Defender',
    Element: 'Wind',
    Weapon: 'RL',
    Manufacturer: 'Elysion',
    New: 'No',
    Limited: 'Yes',
    Investment: 'No',
    Treasure: 'No',
    ID: 7,
    Slug: 'anchor'
  },
  {
    Name: 'Anchor: Innocent Maid',
    Story_LD: 'SS',
    Story_HD: 'S',
    Boss: 'SS',
    PVP: 'S',
    Rarity: 'SSR',
    Burst_Type: 'II',
    Class: 'Supporter',
    Element: 'Water',
    Weapon: 'RL',
    Manufacturer: 'Elysion',
    New: 'No',
    Limited: 'No',
    Investment: 'No',
    Treasure: 'No',
    ID: 153,
    Slug: 'anchor-innocent-maid'
  },
  {
    Name: 'Anis',
    Story_LD: 'A',
    Story_HD: 'C',
    Boss: 'D',
    PVP: 'SS',
    Rarity: 'SR',
    Burst_Type: 'II',
    Class: 'Defender',
    Element: 'Iron',
    Weapon: 'RL',
    Manufacturer: 'Tetra',
    New: 'No',
    Limited: 'No',
    Investment: 'No',
    Treasure: 'No',
    ID: 8,
    Slug: 'anis'
  },
  {
    Name: 'Anis: Sparkling Summer',
    Story_LD: 'S',
    Story_HD: 'S',
    Boss: 'SS',
    PVP: 'SSS',
    Rarity: 'SSR',
    Burst_Type: 'III',
    Class: 'Supporter',
    Element: 'Electric',
    Weapon: 'SG',
    Manufacturer: 'Tetra',
    New: 'No',
    Limited: 'Yes',
    Investment: 'Yes',
    Treasure: 'No',
    ID: 9,
    Slug: 'sparkling-summer-anis'
  },
  {
    Name: 'Anne: Miracle Fairy',
    Story_LD: 'D',
    Story_HD: 'D',
    Boss: 'C',
    PVP: 'S',
    Rarity: 'SSR',
    Burst_Type: 'II',
    Class: 'Supporter',
    Element: 'Wind',
    Weapon: 'RL',
    Manufacturer: 'Missilis',
    New: 'No',
    Limited: 'Yes',
    Investment: 'Yes',
    Treasure: 'No',
    ID: 10,
    Slug: 'miracle-fairy-anne'
  },
  {
    Name: 'Aria',
    Story_LD: 'E',
    Story_HD: 'E',
    Boss: 'C',
    PVP: 'E',
    Rarity: 'SSR',
    Burst_Type: 'II',
    Class: 'Attacker',
    Element: 'Water',
    Weapon: 'MG',
    Manufacturer: 'Tetra',
    New: 'No',
    Limited: 'No',
    Investment: 'No',
    Treasure: 'No',
    ID: 11,
    Slug: 'aria'
  },
  {
    Name: 'Asuka Shikinami Langley',
    Story_LD: 'SSS',
    Story_HD: 'SS',
    Boss: 'SS',
    PVP: 'C',
    Rarity: 'SSR',
    Burst_Type: 'III',
    Class: 'Attacker',
    Element: 'Fire',
    Weapon: 'AR',
    Manufacturer: 'Abnormal',
    New: 'No',
    Limited: 'Yes',
    Investment: 'No',
    Treasure: 'No',
    ID: 135,
    Slug: 'asuka-shikinami-langley'
  },
  {
    Name: 'Bay',
    Story_LD: 'B',
    Story_HD: 'C',
    Boss: 'C',
    PVP: 'S',
    Rarity: 'SSR',
    Burst_Type: 'II',
    Class: 'Defender',
    Element: 'Fire',
    Weapon: 'RL',
    Manufacturer: 'Tetra',
    New: 'No',
    Limited: 'No',
    Investment: 'No',
    Treasure: 'No',
    ID: 12,
    Slug: 'bay'
  },
  {
    Name: 'Belorta',
    Story_LD: 'E',
    Story_HD: 'E',
    Boss: 'E',
    PVP: 'D',
    Rarity: 'SR',
    Burst_Type: 'II',
    Class: 'Attacker',
    Element: 'Electric',
    Weapon: 'RL',
    Manufacturer: 'Tetra',
    New: 'No',
    Limited: 'No',
    Investment: 'No',
    Treasure: 'No',
    ID: 13,
    Slug: 'belorta'
  },
  {
    Name: 'Biscuit',
    Story_LD: 'C',
    Story_HD: 'C',
    Boss: 'B',
    PVP: 'SSS',
    Rarity: 'SSR',
    Burst_Type: 'II',
    Class: 'Supporter',
    Element: 'Electric',
    Weapon: 'RL',
    Manufacturer: 'Tetra',
    New: 'No',
    Limited: 'No',
    Investment: 'No',
    Treasure: 'No',
    ID: 14,
    Slug: 'biscuit'
  },
  {
    Name: 'Blanc',
    Story_LD: 'SS',
    Story_HD: 'S',
    Boss: 'S',
    PVP: 'SS',
    Rarity: 'SSR',
    Burst_Type: 'II',
    Class: 'Defender',
    Element: 'Wind',
    Weapon: 'AR',
    Manufacturer: 'Tetra',
    New: 'No',
    Limited: 'No',
    Investment: 'No',
    Treasure: 'No',
    ID: 15,
    Slug: 'blanc'
  },
  {
    Name: 'Brid',
    Story_LD: 'E',
    Story_HD: 'E',
    Boss: 'E',
    PVP: 'D',
    Rarity: 'SSR',
    Burst_Type: 'III',
    Class: 'Attacker',
    Element: 'Water',
    Weapon: 'AR',
    Manufacturer: 'Elysion',
    New: 'No',
    Limited: 'No',
    Investment: 'No',
    Treasure: 'No',
    ID: 16,
    Slug: 'brid'
  },
  {
    Name: 'Centi',
    Story_LD: 'A',
    Story_HD: 'B',
    Boss: 'C',
    PVP: 'SS',
    Rarity: 'SSR',
    Burst_Type: 'II',
    Class: 'Defender',
    Element: 'Iron',
    Weapon: 'RL',
    Manufacturer: 'Missilis',
    New: 'No',
    Limited: 'No',
    Investment: 'No',
    Treasure: 'No',
    ID: 17,
    Slug: 'centi'
  },
  {
    Name: 'Cinderella',
    Story_LD: 'SS',
    Story_HD: 'S',
    Boss: 'SSS',
    PVP: 'SS',
    Rarity: 'SSR',
    Burst_Type: 'III',
    Class: 'Defender',
    Element: 'Electric',
    Weapon: 'RL',
    Manufacturer: 'Pilgrim',
    New: 'No',
    Limited: 'No',
    Investment: 'No',
    Treasure: 'No',
    ID: 143,
    Slug: 'cinderella'
  },
  {
    Name: 'Clay',
    Story_LD: 'D',
    Story_HD: 'D',
    Boss: 'C',
    PVP: 'D',
    Rarity: 'SSR',
    Burst_Type: 'II',
    Class: 'Supporter',
    Element: 'Electric',
    Weapon: 'SMG',
    Manufacturer: 'Tetra',
    New: 'No',
    Limited: 'No',
    Investment: 'No',
    Treasure: 'No',
    ID: 129,
    Slug: 'clay'
  },
  {
    Name: 'Cocoa',
    Story_LD: 'D',
    Story_HD: 'D',
    Boss: 'C',
    PVP: 'D',
    Rarity: 'SSR',
    Burst_Type: 'I',
    Class: 'Supporter',
    Element: 'Fire',
    Weapon: 'SR',
    Manufacturer: 'Tetra',
    New: 'No',
    Limited: 'No',
    Investment: 'No',
    Treasure: 'No',
    ID: 18,
    Slug: 'cocoa'
  },
  {
    Name: 'Crow',
    Story_LD: 'D',
    Story_HD: 'D',
    Boss: 'D',
    PVP: 'D',
    Rarity: 'SSR',
    Burst_Type: 'III',
    Class: 'Defender',
    Element: 'Fire',
    Weapon: 'SMG',
    Manufacturer: 'Missilis',
    New: 'No',
    Limited: 'No',
    Investment: 'No',
    Treasure: 'No',
    ID: 19,
    Slug: 'crow'
  },
  {
    Name: 'crown',
    Story_LD: 'SSS',
    Story_HD: 'SSS',
    Boss: 'SSS',
    PVP: 'B',
    Rarity: 'SSR',
    Burst_Type: 'II',
    Class: 'Defender',
    Element: 'Iron',
    Weapon: 'MG',
    Manufacturer: 'Pilgrim',
    New: 'No',
    Limited: 'No',
    Investment: 'No',
    Treasure: 'No',
    ID: 20,
    Slug: 'crown'
  },
  {
    Name: 'D',
    Story_LD: 'C',
    Story_HD: 'D',
    Boss: 'C',
    PVP: 'D',
    Rarity: 'SSR',
    Burst_Type: 'III',
    Class: 'Attacker',
    Element: 'Wind',
    Weapon: 'SMG',
    Manufacturer: 'Elysion',
    New: 'No',
    Limited: 'No',
    Investment: 'No',
    Treasure: 'No',
    ID: 21,
    Slug: 'd'
  },
  {
    Name: 'D: Killer Wife',
    Story_LD: 'SS',
    Story_HD: 'SS',
    Boss: 'SSS',
    PVP: 'D',
    Rarity: 'SSR',
    Burst_Type: 'I',
    Class: 'Supporter',
    Element: 'Fire',
    Weapon: 'SR',
    Manufacturer: 'Elysion',
    New: 'No',
    Limited: 'No',
    Investment: 'No',
    Treasure: 'No',
    ID: 22,
    Slug: 'd-killer-wife'
  },
  {
    Name: 'Delta',
    Story_LD: 'E',
    Story_HD: 'E',
    Boss: 'E',
    PVP: 'D',
    Rarity: 'SR',
    Burst_Type: 'II',
    Class: 'Defender',
    Element: 'Wind',
    Weapon: 'SR',
    Manufacturer: 'Elysion',
    New: 'No',
    Limited: 'No',
    Investment: 'No',
    Treasure: 'No',
    ID: 23,
    Slug: 'delta'
  },
  {
    Name: 'Diesel',
    Story_LD: 'D',
    Story_HD: 'D',
    Boss: 'C',
    PVP: 'C',
    Rarity: 'SSR',
    Burst_Type: 'II',
    Class: 'Defender',
    Element: 'Wind',
    Weapon: 'MG',
    Manufacturer: 'Elysion',
    New: 'No',
    Limited: 'No',
    Investment: 'No',
    Treasure: 'No',
    ID: 24,
    Slug: 'diesel'
  },
  {
    Name: 'Diesel (Treasure)',
    Story_LD: 'A',
    Story_HD: 'A',
    Boss: 'B',
    PVP: 'C',
    Rarity: 'SSR',
    Burst_Type: 'II',
    Class: 'Defender',
    Element: 'Wind',
    Weapon: 'MG',
    Manufacturer: 'Elysion',
    New: 'No',
    Limited: 'No',
    Investment: 'No',
    Treasure: 'Yes',
    ID: 25,
    Slug: 'diesel-treasure'
  },
  {
    Name: 'Dolla',
    Story_LD: 'A',
    Story_HD: 'B',
    Boss: 'A',
    PVP: 'D',
    Rarity: 'SSR',
    Burst_Type: 'II',
    Class: 'Supporter',
    Element: 'Wind',
    Weapon: 'SR',
    Manufacturer: 'Tetra',
    New: 'No',
    Limited: 'No',
    Investment: 'No',
    Treasure: 'No',
    ID: 26,
    Slug: 'dolla'
  },
  {
    Name: 'Dorothy',
    Story_LD: 'S',
    Story_HD: 'A',
    Boss: 'S',
    PVP: 'D',
    Rarity: 'SSR',
    Burst_Type: 'I',
    Class: 'Supporter',
    Element: 'Water',
    Weapon: 'AR',
    Manufacturer: 'Pilgrim',
    New: 'No',
    Limited: 'No',
    Investment: 'No',
    Treasure: 'No',
    ID: 27,
    Slug: 'dorothy'
  },
  {
    Name: 'Drake',
    Story_LD: 'B',
    Story_HD: 'C',
    Boss: 'B',
    PVP: 'A',
    Rarity: 'SSR',
    Burst_Type: 'III',
    Class: 'Attacker',
    Element: 'Fire',
    Weapon: 'SG',
    Manufacturer: 'Missilis',
    New: 'No',
    Limited: 'No',
    Investment: 'No',
    Treasure: 'No',
    ID: 28,
    Slug: 'drake'
  },
  {
    Name: 'Ein',
    Story_LD: 'SS',
    Story_HD: 'S',
    Boss: 'S',
    PVP: 'S',
    Rarity: 'SSR',
    Burst_Type: 'III',
    Class: 'Attacker',
    Element: 'Electric',
    Weapon: 'SR',
    Manufacturer: 'Missilis',
    New: 'No',
    Limited: 'No',
    Investment: 'Yes',
    Treasure: 'No',
    ID: 132,
    Slug: 'ein'
  },
  {
    Name: 'Elegg',
    Story_LD: 'B',
    Story_HD: 'C',
    Boss: 'B',
    PVP: 'E',
    Rarity: 'SSR',
    Burst_Type: 'II',
    Class: 'Supporter',
    Element: 'Electric',
    Weapon: 'MG',
    Manufacturer: 'Missilis',
    New: 'No',
    Limited: 'No',
    Investment: 'No',
    Treasure: 'No',
    ID: 29,
    Slug: 'elegg'
  },
  {
    Name: 'Emilia',
    Story_LD: 'S',
    Story_HD: 'A',
    Boss: 'A',
    PVP: 'SSS',
    Rarity: 'SSR',
    Burst_Type: 'III',
    Class: 'Attacker',
    Element: 'Water',
    Weapon: 'RL',
    Manufacturer: 'Abnormal',
    New: 'No',
    Limited: 'Yes',
    Investment: 'No',
    Treasure: 'No',
    ID: 30,
    Slug: 'emilia'
  },
  {
    Name: 'Emma',
    Story_LD: 'D',
    Story_HD: 'D',
    Boss: 'E',
    PVP: 'C',
    Rarity: 'SSR',
    Burst_Type: 'I',
    Class: 'Supporter',
    Element: 'Fire',
    Weapon: 'MG',
    Manufacturer: 'Elysion',
    New: 'No',
    Limited: 'No',
    Investment: 'No',
    Treasure: 'No',
    ID: 31,
    Slug: 'emma'
  },
  {
    Name: 'Epinel',
    Story_LD: 'C',
    Story_HD: 'D',
    Boss: 'C',
    PVP: 'D',
    Rarity: 'SSR',
    Burst_Type: 'III',
    Class: 'Attacker',
    Element: 'Wind',
    Weapon: 'SMG',
    Manufacturer: 'Missilis',
    New: 'No',
    Limited: 'No',
    Investment: 'No',
    Treasure: 'No',
    ID: 32,
    Slug: 'epinel'
  },
  {
    Name: 'Ether',
    Story_LD: 'E',
    Story_HD: 'E',
    Boss: 'E',
    PVP: 'D',
    Rarity: 'SR',
    Burst_Type: 'I',
    Class: 'Defender',
    Element: 'Electric',
    Weapon: 'SG',
    Manufacturer: 'Missilis',
    New: 'No',
    Limited: 'No',
    Investment: 'No',
    Treasure: 'No',
    ID: 33,
    Slug: 'ether'
  },
  {
    Name: 'Eunhwa',
    Story_LD: 'E',
    Story_HD: 'E',
    Boss: 'E',
    PVP: 'E',
    Rarity: 'SSR',
    Burst_Type: 'II',
    Class: 'Attacker',
    Element: 'Fire',
    Weapon: 'SR',
    Manufacturer: 'Elysion',
    New: 'No',
    Limited: 'No',
    Investment: 'No',
    Treasure: 'No',
    ID: 34,
    Slug: 'eunhwa'
  },
  {
    Name: 'Exia (Treasure)',
    Story_LD: 'S',
    Story_HD: 'S',
    Boss: 'S',
    PVP: 'D',
    Rarity: 'SSR',
    Burst_Type: 'I',
    Class: 'Supporter',
    Element: 'Electric',
    Weapon: 'SR',
    Manufacturer: 'Tetra',
    New: 'No',
    Limited: 'No',
    Investment: 'No',
    Treasure: 'Yes',
    ID: 36,
    Slug: 'exia-treasure'
  },
  {
    Name: 'Exia',
    Story_LD: 'C',
    Story_HD: 'C',
    Boss: 'E',
    PVP: 'E',
    Rarity: 'SSR',
    Burst_Type: 'I',
    Class: 'Supporter',
    Element: 'Electric',
    Weapon: 'SR',
    Manufacturer: 'Tetra',
    New: 'No',
    Limited: 'No',
    Investment: 'No',
    Treasure: 'No',
    ID: 35,
    Slug: 'exia'
  },
  {
    Name: 'Flora',
    Story_LD: 'C',
    Story_HD: 'D',
    Boss: 'C',
    PVP: 'E',
    Rarity: 'SSR',
    Burst_Type: 'II',
    Class: 'Supporter',
    Element: 'Electric',
    Weapon: 'LMG',
    Manufacturer: 'Missilis',
    New: 'No',
    Limited: 'No',
    Investment: 'No',
    Treasure: 'No',
    ID: 146,
    Slug: 'flora'
  },
  {
    Name: 'Folkwang',
    Story_LD: 'E',
    Story_HD: 'E',
    Boss: 'C',
    PVP: 'C',
    Rarity: 'SSR',
    Burst_Type: 'II',
    Class: 'Defender',
    Element: 'Water',
    Weapon: 'AR',
    Manufacturer: 'Tetra',
    New: 'No',
    Limited: 'No',
    Investment: 'No',
    Treasure: 'No',
    ID: 37,
    Slug: 'folkwang'
  },
  {
    Name: 'frima',
    Story_LD: 'D',
    Story_HD: 'D',
    Boss: 'E',
    PVP: 'D',
    Rarity: 'SSR',
    Burst_Type: 'I',
    Class: 'Supporter',
    Element: 'Iron',
    Weapon: 'SR',
    Manufacturer: 'Tetra',
    New: 'No',
    Limited: 'No',
    Investment: 'No',
    Treasure: 'No',
    ID: 38,
    Slug: 'frima'
  },
  {
    Name: 'Frima (Treasure)',
    Story_LD: 'B',
    Story_HD: 'B',
    Boss: 'B',
    PVP: 'D',
    Rarity: 'SSR',
    Burst_Type: 'I',
    Class: 'Supporter',
    Element: 'Iron',
    Weapon: 'SR',
    Manufacturer: 'Tetra',
    New: 'No',
    Limited: 'No',
    Investment: 'No',
    Treasure: 'Yes',
    ID: 39,
    Slug: 'frima-treasure'
  },
  {
    Name: 'Grave',
    Story_LD: 'SS',
    Story_HD: 'S',
    Boss: 'SS',
    PVP: 'B',
    Rarity: 'SSR',
    Burst_Type: 'II',
    Class: 'Supporter',
    Element: 'Fire',
    Weapon: 'AR',
    Manufacturer: 'Pilgrim',
    New: 'No',
    Limited: 'No',
    Investment: 'No',
    Treasure: 'No',
    ID: 144,
    Slug: 'grave'
  },
  {
    Name: 'Guillotine',
    Story_LD: 'B',
    Story_HD: 'C',
    Boss: 'B',
    PVP: 'D',
    Rarity: 'SSR',
    Burst_Type: 'III',
    Class: 'Attacker',
    Element: 'Electric',
    Weapon: 'MG',
    Manufacturer: 'Elysion',
    New: 'No',
    Limited: 'No',
    Investment: 'Yes',
    Treasure: 'No',
    ID: 40,
    Slug: 'guillotine'
  },
  {
    Name: 'Guillotine: Winter Slayer',
    Story_LD: 'C',
    Story_HD: 'C',
    Boss: 'A',
    PVP: 'E',
    Rarity: 'SSR',
    Burst_Type: 'III',
    Class: 'Attacker',
    Element: 'Water',
    Weapon: 'AR',
    Manufacturer: 'Elysion',
    New: 'No',
    Limited: 'Yes',
    Investment: 'No',
    Treasure: 'No',
    ID: 147,
    Slug: 'guillotine-winter-slayer'
  },
  {
    Name: 'Guilty',
    Story_LD: 'C',
    Story_HD: 'C',
    Boss: 'A',
    PVP: 'D',
    Rarity: 'SSR',
    Burst_Type: 'II',
    Class: 'Attacker',
    Element: 'Wind',
    Weapon: 'SG',
    Manufacturer: 'Missilis',
    New: 'No',
    Limited: 'No',
    Investment: 'No',
    Treasure: 'No',
    ID: 41,
    Slug: 'guilty'
  },
  {
    Name: 'Harran',
    Story_LD: 'B',
    Story_HD: 'B',
    Boss: 'E',
    PVP: 'B',
    Rarity: 'SSR',
    Burst_Type: 'III',
    Class: 'Attacker',
    Element: 'Electric',
    Weapon: 'SR',
    Manufacturer: 'Pilgrim',
    New: 'No',
    Limited: 'No',
    Investment: 'No',
    Treasure: 'No',
    ID: 42,
    Slug: 'harran'
  },
  {
    Name: 'Helm',
    Story_LD: 'C',
    Story_HD: 'C',
    Boss: 'A',
    PVP: 'D',
    Rarity: 'SSR',
    Burst_Type: 'III',
    Class: 'Attacker',
    Element: 'Water',
    Weapon: 'SR',
    Manufacturer: 'Elysion',
    New: 'No',
    Limited: 'No',
    Investment: 'No',
    Treasure: 'No',
    ID: 43,
    Slug: 'helm'
  },
  {
    Name: 'Helm (Treasure)',
    Story_LD: 'SSS',
    Story_HD: 'SS',
    Boss: 'SS',
    PVP: 'SSS',
    Rarity: 'SSR',
    Burst_Type: 'III',
    Class: 'Attacker',
    Element: 'Water',
    Weapon: 'SR',
    Manufacturer: 'Elysion',
    New: 'No',
    Limited: 'No',
    Investment: 'No',
    Treasure: 'Yes',
    ID: 154,
    Slug: 'helm-treasure'
  },
  {
    Name: 'Helm: Aquamarine',
    Story_LD: 'A',
    Story_HD: 'B',
    Boss: 'S',
    PVP: 'D',
    Rarity: 'SSR',
    Burst_Type: 'II',
    Class: 'Attacker',
    Element: 'Iron',
    Weapon: 'AR',
    Manufacturer: 'Elysion',
    New: 'No',
    Limited: 'Yes',
    Investment: 'No',
    Treasure: 'No',
    ID: 44,
    Slug: 'aqua-marine-helm'
  },
  {
    Name: 'Himeno',
    Story_LD: 'E',
    Story_HD: 'E',
    Boss: 'E',
    PVP: 'E',
    Rarity: 'SR',
    Burst_Type: 'II',
    Class: 'Supporter',
    Element: 'Wind',
    Weapon: 'SR',
    Manufacturer: 'Abnormal',
    New: 'No',
    Limited: 'Yes',
    Investment: 'No',
    Treasure: 'No',
    ID: 45,
    Slug: 'himeno'
  },
  {
    Name: 'iDoll Flower',
    Story_LD: 'F',
    Story_HD: 'F',
    Boss: 'F',
    PVP: 'E',
    Rarity: 'R',
    Burst_Type: 'I',
    Class: 'Defender',
    Element: 'Wind',
    Weapon: 'RL',
    Manufacturer: 'Tetra',
    New: 'No',
    Limited: 'No',
    Investment: 'No',
    Treasure: 'No',
    ID: 46,
    Slug: 'idoll-flower'
  },
  {
    Name: 'iDoll Ocean',
    Story_LD: 'F',
    Story_HD: 'F',
    Boss: 'F',
    PVP: 'F',
    Rarity: 'R',
    Burst_Type: 'I',
    Class: 'Supporter',
    Element: 'Water',
    Weapon: 'SMG',
    Manufacturer: 'Tetra',
    New: 'No',
    Limited: 'No',
    Investment: 'No',
    Treasure: 'No',
    ID: 47,
    Slug: 'idoll-ocean'
  },
  {
    Name: 'iDoll Sun',
    Story_LD: 'F',
    Story_HD: 'F',
    Boss: 'F',
    PVP: 'F',
    Rarity: 'R',
    Burst_Type: 'III',
    Class: 'Supporter',
    Element: 'Iron',
    Weapon: 'AR',
    Manufacturer: 'Tetra',
    New: 'No',
    Limited: 'No',
    Investment: 'No',
    Treasure: 'No',
    ID: 48,
    Slug: 'idoll-sun'
  },
  {
    Name: 'Isabel',
    Story_LD: 'E',
    Story_HD: 'E',
    Boss: 'D',
    PVP: 'D',
    Rarity: 'SSR',
    Burst_Type: 'III',
    Class: 'Attacker',
    Element: 'Electric',
    Weapon: 'SG',
    Manufacturer: 'Pilgrim',
    New: 'No',
    Limited: 'No',
    Investment: 'No',
    Treasure: 'No',
    ID: 49,
    Slug: 'isabel'
  },
  {
    Name: 'Jackal',
    Story_LD: 'C',
    Story_HD: 'C',
    Boss: 'D',
    PVP: 'SSS',
    Rarity: 'SSR',
    Burst_Type: 'I',
    Class: 'Defender',
    Element: 'Iron',
    Weapon: 'RL',
    Manufacturer: 'Missilis',
    New: 'No',
    Limited: 'No',
    Investment: 'No',
    Treasure: 'No',
    ID: 50,
    Slug: 'jackal'
  },
  {
    Name: 'Julia',
    Story_LD: 'D',
    Story_HD: 'E',
    Boss: 'E',
    PVP: 'D',
    Rarity: 'SSR',
    Burst_Type: 'III',
    Class: 'Attacker',
    Element: 'Iron',
    Weapon: 'AR',
    Manufacturer: 'Missilis',
    New: 'No',
    Limited: 'No',
    Investment: 'No',
    Treasure: 'No',
    ID: 51,
    Slug: 'julia'
  },
  {
    Name: 'kilo',
    Story_LD: 'C',
    Story_HD: 'C',
    Boss: 'E',
    PVP: 'B',
    Rarity: 'SSR',
    Burst_Type: 'III',
    Class: 'Defender',
    Element: 'Fire',
    Weapon: 'MG',
    Manufacturer: 'Missilis',
    New: 'No',
    Limited: 'Yes',
    Investment: 'No',
    Treasure: 'No',
    ID: 52,
    Slug: 'kilo'
  },
  {
    Name: 'Laplace (Treasure)',
    Story_LD: 'S',
    Story_HD: 'A',
    Boss: 'S',
    PVP: 'SS',
    Rarity: 'SSR',
    Burst_Type: 'III',
    Class: 'Attacker',
    Element: 'Iron',
    Weapon: 'RL',
    Manufacturer: 'Missilis',
    New: 'No',
    Limited: 'No',
    Investment: 'No',
    Treasure: 'Yes',
    ID: 54,
    Slug: 'laplace-treasure'
  },
  {
    Name: 'Laplace',
    Story_LD: 'B',
    Story_HD: 'C',
    Boss: 'C',
    PVP: 'C',
    Rarity: 'SSR',
    Burst_Type: 'III',
    Class: 'Attacker',
    Element: 'Iron',
    Weapon: 'RL',
    Manufacturer: 'Missilis',
    New: 'No',
    Limited: 'No',
    Investment: 'No',
    Treasure: 'No',
    ID: 53,
    Slug: 'laplace'
  },
  {
    Name: 'Leona',
    Story_LD: 'D',
    Story_HD: 'D',
    Boss: 'A',
    PVP: 'D',
    Rarity: 'SSR',
    Burst_Type: 'II',
    Class: 'Supporter',
    Element: 'Water',
    Weapon: 'SG',
    Manufacturer: 'Tetra',
    New: 'No',
    Limited: 'No',
    Investment: 'No',
    Treasure: 'No',
    ID: 55,
    Slug: 'leona'
  },
  {
    Name: 'Liter',
    Story_LD: 'SSS',
    Story_HD: 'SS',
    Boss: 'SSS',
    PVP: 'B',
    Rarity: 'SSR',
    Burst_Type: 'I',
    Class: 'Supporter',
    Element: 'Iron',
    Weapon: 'SMG',
    Manufacturer: 'Missilis',
    New: 'No',
    Limited: 'No',
    Investment: 'No',
    Treasure: 'No',
    ID: 56,
    Slug: 'liter'
  },
  {
    Name: 'Ludmilla',
    Story_LD: 'C',
    Story_HD: 'C',
    Boss: 'D',
    PVP: 'C',
    Rarity: 'SSR',
    Burst_Type: 'I',
    Class: 'Defender',
    Element: 'Water',
    Weapon: 'SMG',
    Manufacturer: 'Tetra',
    New: 'No',
    Limited: 'No',
    Investment: 'No',
    Treasure: 'No',
    ID: 57,
    Slug: 'ludmilla'
  },
  {
    Name: 'Ludmilla: Winter Owner',
    Story_LD: 'S',
    Story_HD: 'S',
    Boss: 'SS',
    PVP: 'D',
    Rarity: 'SSR',
    Burst_Type: 'III',
    Class: 'Attacker',
    Element: 'Water',
    Weapon: 'MG',
    Manufacturer: 'Tetra',
    New: 'No',
    Limited: 'Yes',
    Investment: 'No',
    Treasure: 'No',
    ID: 58,
    Slug: 'ludmilla-winter-owner'
  },
  {
    Name: 'Maiden',
    Story_LD: 'D',
    Story_HD: 'E',
    Boss: 'C',
    PVP: 'A',
    Rarity: 'SSR',
    Burst_Type: 'III',
    Class: 'Attacker',
    Element: 'Electric',
    Weapon: 'SG',
    Manufacturer: 'Elysion',
    New: 'No',
    Limited: 'No',
    Investment: 'No',
    Treasure: 'No',
    ID: 59,
    Slug: 'maiden'
  },
  {
    Name: 'Maiden: Ice Rose',
    Story_LD: 'A',
    Story_HD: 'B',
    Boss: 'SS',
    PVP: 'SS',
    Rarity: 'SSR',
    Burst_Type: 'III',
    Class: 'Defender',
    Element: 'Electric',
    Weapon: 'RL',
    Manufacturer: 'Elysion',
    New: 'No',
    Limited: 'Yes',
    Investment: 'No',
    Treasure: 'No',
    ID: 148,
    Slug: 'maiden-ice-rose'
  },
  {
    Name: 'Makima',
    Story_LD: 'C',
    Story_HD: 'C',
    Boss: 'D',
    PVP: 'A',
    Rarity: 'SSR',
    Burst_Type: 'II',
    Class: 'Defender',
    Element: 'Water',
    Weapon: 'SMG',
    Manufacturer: 'Abnormal',
    New: 'No',
    Limited: 'Yes',
    Investment: 'No',
    Treasure: 'No',
    ID: 60,
    Slug: 'makima'
  },
  {
    Name: 'Mana',
    Story_LD: 'A',
    Story_HD: 'A',
    Boss: 'S',
    PVP: 'S',
    Rarity: 'SSR',
    Burst_Type: 'III',
    Class: 'Attacker',
    Element: 'Wind',
    Weapon: 'AR',
    Manufacturer: 'Missilis',
    New: 'No',
    Limited: 'No',
    Investment: 'No',
    Treasure: 'No',
    ID: 151,
    Slug: 'mana'
  },
  {
    Name: 'Marciana',
    Story_LD: 'A',
    Story_HD: 'B',
    Boss: 'A',
    PVP: 'D',
    Rarity: 'SSR',
    Burst_Type: 'II',
    Class: 'Supporter',
    Element: 'Iron',
    Weapon: 'SG',
    Manufacturer: 'Elysion',
    New: 'No',
    Limited: 'No',
    Investment: 'No',
    Treasure: 'No',
    ID: 61,
    Slug: 'marciana'
  },
  {
    Name: 'Mari Makinami Illustrious',
    Story_LD: 'S',
    Story_HD: 'S',
    Boss: 'S',
    PVP: 'A',
    Rarity: 'SSR',
    Burst_Type: 'II',
    Class: 'Supporter',
    Element: 'Electric',
    Weapon: 'SR',
    Manufacturer: 'Abnormal',
    New: 'No',
    Limited: 'Yes',
    Investment: 'No',
    Treasure: 'No',
    ID: 137,
    Slug: 'mari-makinami-illustrious'
  },
  {
    Name: 'Mary',
    Story_LD: 'D',
    Story_HD: 'D',
    Boss: 'E',
    PVP: 'D',
    Rarity: 'SSR',
    Burst_Type: 'I',
    Class: 'Supporter',
    Element: 'Water',
    Weapon: 'SG',
    Manufacturer: 'Tetra',
    New: 'No',
    Limited: 'No',
    Investment: 'No',
    Treasure: 'No',
    ID: 62,
    Slug: 'mary'
  },
  {
    Name: 'Mary: Bay Goddess',
    Story_LD: 'A',
    Story_HD: 'B',
    Boss: 'B',
    PVP: 'D',
    Rarity: 'SSR',
    Burst_Type: 'I',
    Class: 'Supporter',
    Element: 'Water',
    Weapon: 'SR',
    Manufacturer: 'Tetra',
    New: 'No',
    Limited: 'Yes',
    Investment: 'No',
    Treasure: 'No',
    ID: 63,
    Slug: 'bay-goddess-mary'
  },
  {
    Name: 'Mast',
    Story_LD: 'D',
    Story_HD: 'D',
    Boss: 'B',
    PVP: 'C',
    Rarity: 'SSR',
    Burst_Type: 'II',
    Class: 'Supporter',
    Element: 'Electric',
    Weapon: 'SMG',
    Manufacturer: 'Elysion',
    New: 'No',
    Limited: 'No',
    Investment: 'No',
    Treasure: 'No',
    ID: 64,
    Slug: 'mast'
  },
  {
    Name: 'Mast: Romantic Maid',
    Story_LD: 'SS',
    Story_HD: 'S',
    Boss: 'SS',
    PVP: 'C',
    Rarity: 'SSR',
    Burst_Type: 'II',
    Class: 'Supporter',
    Element: 'Water',
    Weapon: 'MG',
    Manufacturer: 'Elysion',
    New: 'No',
    Limited: 'No',
    Investment: 'No',
    Treasure: 'No',
    ID: 152,
    Slug: 'mast-romantic-maid'
  },
  {
    Name: 'Maxwell',
    Story_LD: 'S',
    Story_HD: 'S',
    Boss: 'S',
    PVP: 'C',
    Rarity: 'SSR',
    Burst_Type: 'III',
    Class: 'Attacker',
    Element: 'Iron',
    Weapon: 'SR',
    Manufacturer: 'Missilis',
    New: 'No',
    Limited: 'No',
    Investment: 'Yes',
    Treasure: 'No',
    ID: 65,
    Slug: 'maxwell'
  },
  {
    Name: 'Mica',
    Story_LD: 'D',
    Story_HD: 'E',
    Boss: 'E',
    PVP: 'D',
    Rarity: 'SR',
    Burst_Type: 'I',
    Class: 'Supporter',
    Element: 'Wind',
    Weapon: 'RL',
    Manufacturer: 'Tetra',
    New: 'No',
    Limited: 'No',
    Investment: 'No',
    Treasure: 'No',
    ID: 66,
    Slug: 'mica'
  },
  {
    Name: 'Mica: Snow Buddy',
    Story_LD: 'B',
    Story_HD: 'B',
    Boss: 'A',
    PVP: 'B',
    Rarity: 'SSR',
    Burst_Type: 'I',
    Class: 'Supporter',
    Element: 'Iron',
    Weapon: 'SMG',
    Manufacturer: 'Tetra',
    New: 'No',
    Limited: 'Yes',
    Investment: 'No',
    Treasure: 'No',
    ID: 67,
    Slug: 'mica-snow-buddy'
  },
  {
    Name: 'Mihara',
    Story_LD: 'E',
    Story_HD: 'E',
    Boss: 'E',
    PVP: 'E',
    Rarity: 'SR',
    Burst_Type: 'III',
    Class: 'Attacker',
    Element: 'Water',
    Weapon: 'AR',
    Manufacturer: 'Missilis',
    New: 'No',
    Limited: 'No',
    Investment: 'No',
    Treasure: 'No',
    ID: 68,
    Slug: 'mihara'
  },
  {
    Name: 'Milk',
    Story_LD: 'D',
    Story_HD: 'D',
    Boss: 'D',
    PVP: 'D',
    Rarity: 'SSR',
    Burst_Type: 'I',
    Class: 'Attacker',
    Element: 'Water',
    Weapon: 'SR',
    Manufacturer: 'Tetra',
    New: 'No',
    Limited: 'No',
    Investment: 'No',
    Treasure: 'No',
    ID: 69,
    Slug: 'milk'
  },
  {
    Name: 'Milk (Treasure)',
    Story_LD: 'B',
    Story_HD: 'B',
    Boss: 'C',
    PVP: 'C',
    Rarity: 'SSR',
    Burst_Type: 'I',
    Class: 'Attacker',
    Element: 'Water',
    Weapon: 'SR',
    Manufacturer: 'Tetra',
    New: 'No',
    Limited: 'No',
    Investment: 'No',
    Treasure: 'Yes',
    ID: 159,
    Slug: 'milk-treasure'
  },
  {
    Name: 'Miranda',
    Story_LD: 'B',
    Story_HD: 'B',
    Boss: 'B',
    PVP: 'C',
    Rarity: 'SSR',
    Burst_Type: 'I',
    Class: 'Supporter',
    Element: 'Fire',
    Weapon: 'SMG',
    Manufacturer: 'Elysion',
    New: 'No',
    Limited: 'No',
    Investment: 'No',
    Treasure: 'No',
    ID: 70,
    Slug: 'miranda'
  },
  {
    Name: 'Miranda (Treasure)',
    Story_LD: 'A',
    Story_HD: 'A',
    Boss: 'A',
    PVP: 'B',
    Rarity: 'SSR',
    Burst_Type: 'I',
    Class: 'Supporter',
    Element: 'Fire',
    Weapon: 'SMG',
    Manufacturer: 'Elysion',
    New: 'No',
    Limited: 'No',
    Investment: 'No',
    Treasure: 'Yes',
    ID: 160,
    Slug: 'miranda-treasure'
  },
  {
    Name: 'Misato Katsuragi',
    Story_LD: 'E',
    Story_HD: 'E',
    Boss: 'D',
    PVP: 'E',
    Rarity: 'SR',
    Burst_Type: 'I',
    Class: 'Supporter',
    Element: 'Iron',
    Weapon: 'SMG',
    Manufacturer: 'Abnormal',
    New: 'No',
    Limited: 'Yes',
    Investment: 'No',
    Treasure: 'No',
    ID: 138,
    Slug: 'misato-katsuragi'
  },
  {
    Name: 'Modernia',
    Story_LD: 'SS',
    Story_HD: 'S',
    Boss: 'S',
    PVP: 'C',
    Rarity: 'SSR',
    Burst_Type: 'III',
    Class: 'Attacker',
    Element: 'Fire',
    Weapon: 'MG',
    Manufacturer: 'Pilgrim',
    New: 'No',
    Limited: 'No',
    Investment: 'No',
    Treasure: 'No',
    ID: 71,
    Slug: 'modernia'
  },
  {
    Name: 'Moran',
    Story_LD: 'C',
    Story_HD: 'C',
    Boss: 'C',
    PVP: 'SS',
    Rarity: 'SSR',
    Burst_Type: 'I',
    Class: 'Defender',
    Element: 'Electric',
    Weapon: 'AR',
    Manufacturer: 'Tetra',
    New: 'No',
    Limited: 'No',
    Investment: 'No',
    Treasure: 'No',
    ID: 72,
    Slug: 'moran'
  },
  {
    Name: 'N102',
    Story_LD: 'B',
    Story_HD: 'B',
    Boss: 'C',
    PVP: 'D',
    Rarity: 'SR',
    Burst_Type: 'I',
    Class: 'Supporter',
    Element: 'Water',
    Weapon: 'RL',
    Manufacturer: 'Missilis',
    New: 'No',
    Limited: 'No',
    Investment: 'No',
    Treasure: 'No',
    ID: 73,
    Slug: 'n102'
  },
  {
    Name: 'Naga',
    Story_LD: 'SSS',
    Story_HD: 'SS',
    Boss: 'SS',
    PVP: 'C',
    Rarity: 'SSR',
    Burst_Type: 'II',
    Class: 'Supporter',
    Element: 'Electric',
    Weapon: 'SG',
    Manufacturer: 'Missilis',
    New: 'No',
    Limited: 'No',
    Investment: 'No',
    Treasure: 'No',
    ID: 74,
    Slug: 'naga'
  },
  {
    Name: 'Neon',
    Story_LD: 'E',
    Story_HD: 'E',
    Boss: 'D',
    PVP: 'C',
    Rarity: 'SR',
    Burst_Type: 'I',
    Class: 'Supporter',
    Element: 'Fire',
    Weapon: 'SG',
    Manufacturer: 'Elysion',
    New: 'No',
    Limited: 'No',
    Investment: 'No',
    Treasure: 'No',
    ID: 75,
    Slug: 'neon'
  },
  {
    Name: 'Neon: Blue Ocean',
    Story_LD: 'E',
    Story_HD: 'E',
    Boss: 'D',
    PVP: 'E',
    Rarity: 'SSR',
    Burst_Type: 'III',
    Class: 'Attacker',
    Element: 'Water',
    Weapon: 'MG',
    Manufacturer: 'Elysion',
    New: 'No',
    Limited: 'Yes',
    Investment: 'Yes',
    Treasure: 'No',
    ID: 76,
    Slug: 'blue-ocean-neon'
  },
  {
    Name: 'Nero',
    Story_LD: 'E',
    Story_HD: 'E',
    Boss: 'D',
    PVP: 'S',
    Rarity: 'SSR',
    Burst_Type: 'II',
    Class: 'Defender',
    Element: 'Fire',
    Weapon: 'SMG',
    Manufacturer: 'Tetra',
    New: 'No',
    Limited: 'No',
    Investment: 'No',
    Treasure: 'No',
    ID: 77,
    Slug: 'nero'
  },
  {
    Name: 'Neve',
    Story_LD: 'D',
    Story_HD: 'D',
    Boss: 'B',
    PVP: 'D',
    Rarity: 'SR',
    Burst_Type: 'III',
    Class: 'Attacker',
    Element: 'Water',
    Weapon: 'SG',
    Manufacturer: 'Tetra',
    New: 'No',
    Limited: 'No',
    Investment: 'No',
    Treasure: 'No',
    ID: 78,
    Slug: 'neve'
  },
  {
    Name: 'Nihilister',
    Story_LD: 'D',
    Story_HD: 'D',
    Boss: 'D',
    PVP: 'B',
    Rarity: 'SSR',
    Burst_Type: 'II',
    Class: 'Attacker',
    Element: 'Fire',
    Weapon: 'SR',
    Manufacturer: 'Pilgrim',
    New: 'No',
    Limited: 'No',
    Investment: 'No',
    Treasure: 'No',
    ID: 79,
    Slug: 'nihilister'
  },
  {
    Name: 'Noah',
    Story_LD: 'C',
    Story_HD: 'C',
    Boss: 'C',
    PVP: 'SSS',
    Rarity: 'SSR',
    Burst_Type: 'II',
    Class: 'Defender',
    Element: 'Wind',
    Weapon: 'RL',
    Manufacturer: 'Pilgrim',
    New: 'No',
    Limited: 'No',
    Investment: 'No',
    Treasure: 'No',
    ID: 80,
    Slug: 'noah'
  },
  {
    Name: 'Noir',
    Story_LD: 'S',
    Story_HD: 'A',
    Boss: 'S',
    PVP: 'S',
    Rarity: 'SSR',
    Burst_Type: 'III',
    Class: 'Attacker',
    Element: 'Wind',
    Weapon: 'SG',
    Manufacturer: 'Tetra',
    New: 'No',
    Limited: 'No',
    Investment: 'No',
    Treasure: 'No',
    ID: 81,
    Slug: 'noir'
  },
  {
    Name: 'Noise',
    Story_LD: 'B',
    Story_HD: 'B',
    Boss: 'A',
    PVP: 'SS',
    Rarity: 'SSR',
    Burst_Type: 'I',
    Class: 'Supporter',
    Element: 'Electric',
    Weapon: 'RL',
    Manufacturer: 'Tetra',
    New: 'No',
    Limited: 'No',
    Investment: 'No',
    Treasure: 'No',
    ID: 82,
    Slug: 'noise'
  },
  {
    Name: 'Novel',
    Story_LD: 'E',
    Story_HD: 'E',
    Boss: 'B',
    PVP: 'E',
    Rarity: 'SSR',
    Burst_Type: 'II',
    Class: 'Defender',
    Element: 'Iron',
    Weapon: 'SMG',
    Manufacturer: 'Tetra',
    New: 'No',
    Limited: 'No',
    Investment: 'Yes',
    Treasure: 'No',
    ID: 83,
    Slug: 'novel'
  },
  {
    Name: 'Pascal',
    Story_LD: 'E',
    Story_HD: 'E',
    Boss: 'E',
    PVP: 'C',
    Rarity: 'SR',
    Burst_Type: 'I',
    Class: 'Supporter',
    Element: 'Iron',
    Weapon: 'RL',
    Manufacturer: 'Abnormal',
    New: 'No',
    Limited: 'Yes',
    Investment: 'No',
    Treasure: 'No',
    ID: 84,
    Slug: 'pascal'
  },
  {
    Name: 'Pepper',
    Story_LD: 'B',
    Story_HD: 'B',
    Boss: 'C',
    PVP: 'A',
    Rarity: 'SSR',
    Burst_Type: 'I',
    Class: 'Supporter',
    Element: 'Wind',
    Weapon: 'SG',
    Manufacturer: 'Missilis',
    New: 'No',
    Limited: 'No',
    Investment: 'No',
    Treasure: 'No',
    ID: 85,
    Slug: 'pepper'
  },
  {
    Name: 'Phantom',
    Story_LD: 'A',
    Story_HD: 'A',
    Boss: 'A',
    PVP: 'C',
    Rarity: 'SSR',
    Burst_Type: 'III',
    Class: 'Attacker',
    Element: 'Water',
    Weapon: 'AR',
    Manufacturer: 'Elysion',
    New: 'No',
    Limited: 'No',
    Investment: 'No',
    Treasure: 'No',
    ID: 141,
    Slug: 'phantom'
  },
  {
    Name: 'Poli',
    Story_LD: 'B',
    Story_HD: 'C',
    Boss: 'B',
    PVP: 'C',
    Rarity: 'SSR',
    Burst_Type: 'II',
    Class: 'Defender',
    Element: 'Water',
    Weapon: 'SG',
    Manufacturer: 'Elysion',
    New: 'No',
    Limited: 'No',
    Investment: 'No',
    Treasure: 'No',
    ID: 86,
    Slug: 'poli'
  },
  {
    Name: 'Power',
    Story_LD: 'C',
    Story_HD: 'D',
    Boss: 'C',
    PVP: 'C',
    Rarity: 'SSR',
    Burst_Type: 'III',
    Class: 'Attacker',
    Element: 'Fire',
    Weapon: 'RL',
    Manufacturer: 'Abnormal',
    New: 'No',
    Limited: 'Yes',
    Investment: 'No',
    Treasure: 'No',
    ID: 87,
    Slug: 'power'
  },
  {
    Name: 'Privaty',
    Story_LD: 'A',
    Story_HD: 'A',
    Boss: 'A',
    PVP: 'C',
    Rarity: 'SSR',
    Burst_Type: 'III',
    Class: 'Attacker',
    Element: 'Water',
    Weapon: 'AR',
    Manufacturer: 'Elysion',
    New: 'No',
    Limited: 'No',
    Investment: 'Yes',
    Treasure: 'No',
    ID: 88,
    Slug: 'privaty'
  },
  {
    Name: 'Privaty: Unkind Maid',
    Story_LD: 'A',
    Story_HD: 'B',
    Boss: 'S',
    PVP: 'A',
    Rarity: 'SSR',
    Burst_Type: 'III',
    Class: 'Attacker',
    Element: 'Electric',
    Weapon: 'SG',
    Manufacturer: 'Elysion',
    New: 'No',
    Limited: 'No',
    Investment: 'No',
    Treasure: 'No',
    ID: 89,
    Slug: 'privaty-unkind-maid'
  },
  {
    Name: 'Product-08',
    Story_LD: 'F',
    Story_HD: 'F',
    Boss: 'F',
    PVP: 'F',
    Rarity: 'R',
    Burst_Type: 'I',
    Class: 'Supporter',
    Element: 'Electric',
    Weapon: 'SR',
    Manufacturer: 'Missilis',
    New: 'No',
    Limited: 'No',
    Investment: 'No',
    Treasure: 'No',
    ID: 90,
    Slug: 'product-08'
  },
  {
    Name: 'Product-12',
    Story_LD: 'F',
    Story_HD: 'F',
    Boss: 'F',
    PVP: 'F',
    Rarity: 'R',
    Burst_Type: 'III',
    Class: 'Attacker',
    Element: 'Fire',
    Weapon: 'MG',
    Manufacturer: 'Missilis',
    New: 'No',
    Limited: 'No',
    Investment: 'No',
    Treasure: 'No',
    ID: 91,
    Slug: 'product-12'
  },
  {
    Name: 'Product-23',
    Story_LD: 'F',
    Story_HD: 'F',
    Boss: 'F',
    PVP: 'C',
    Rarity: 'R',
    Burst_Type: 'II',
    Class: 'Supporter',
    Element: 'Wind',
    Weapon: 'SG',
    Manufacturer: 'Missilis',
    New: 'No',
    Limited: 'No',
    Investment: 'No',
    Treasure: 'No',
    ID: 92,
    Slug: 'product-23'
  },
  {
    Name: 'Quency',
    Story_LD: 'B',
    Story_HD: 'C',
    Boss: 'C',
    PVP: 'E',
    Rarity: 'SSR',
    Burst_Type: 'II',
    Class: 'Supporter',
    Element: 'Electric',
    Weapon: 'SMG',
    Manufacturer: 'Missilis',
    New: 'No',
    Limited: 'No',
    Investment: 'No',
    Treasure: 'No',
    ID: 93,
    Slug: 'quency'
  },
  {
    Name: 'Quency: Escape Queen',
    Story_LD: 'A',
    Story_HD: 'A',
    Boss: 'S',
    PVP: 'A',
    Rarity: 'SSR',
    Burst_Type: 'III',
    Class: 'Attacker',
    Element: 'Water',
    Weapon: 'SMG',
    Manufacturer: 'Missilis',
    New: 'No',
    Limited: 'No',
    Investment: 'No',
    Treasure: 'No',
    ID: 140,
    Slug: 'quency-escape-queen'
  },
  {
    Name: 'Quiry',
    Story_LD: 'D',
    Story_HD: 'D',
    Boss: 'D',
    PVP: 'A',
    Rarity: 'SSR',
    Burst_Type: 'III',
    Class: 'Supporter',
    Element: 'Wind',
    Weapon: 'RL',
    Manufacturer: 'Elysion',
    New: 'No',
    Limited: 'No',
    Investment: 'No',
    Treasure: 'No',
    ID: 94,
    Slug: 'quiry'
  },
  {
    Name: 'Ram',
    Story_LD: 'E',
    Story_HD: 'E',
    Boss: 'D',
    PVP: 'E',
    Rarity: 'SR',
    Burst_Type: 'I',
    Class: 'Defender',
    Element: 'Wind',
    Weapon: 'SR',
    Manufacturer: 'Abnormal',
    New: 'No',
    Limited: 'Yes',
    Investment: 'No',
    Treasure: 'No',
    ID: 95,
    Slug: 'ram'
  },
  {
    Name: 'Rapi',
    Story_LD: 'D',
    Story_HD: 'D',
    Boss: 'E',
    PVP: 'E',
    Rarity: 'SR',
    Burst_Type: 'III',
    Class: 'Attacker',
    Element: 'Fire',
    Weapon: 'AR',
    Manufacturer: 'Elysion',
    New: 'No',
    Limited: 'No',
    Investment: 'No',
    Treasure: 'No',
    ID: 96,
    Slug: 'rapi'
  },
  {
    Name: 'Rapi: Red Hood',
    Story_LD: 'SSS',
    Story_HD: 'SSS',
    Boss: 'SSS',
    PVP: 'A',
    Rarity: 'SSR',
    Burst_Type: 'III',
    Class: 'Attacker',
    Element: 'Fire',
    Weapon: 'MG',
    Manufacturer: 'Elysion',
    New: 'No',
    Limited: 'No',
    Investment: 'No',
    Treasure: 'No',
    ID: 150,
    Slug: 'rapi-red-hood'
  },
  {
    Name: 'Rapi: Red Hood',
    Story_LD: 'SSS',
    Story_HD: 'SSS',
    Boss: 'SSS',
    PVP: 'E',
    Rarity: 'SSR',
    Burst_Type: 'I',
    Class: 'Attacker',
    Element: 'Fire',
    Weapon: 'MG',
    Manufacturer: 'Elysion',
    New: 'No',
    Limited: 'No',
    Investment: 'No',
    Treasure: 'No',
    ID: 149,
    Slug: 'rapi-red-hood'
  },
  {
    Name: 'Rapunzel',
    Story_LD: 'S',
    Story_HD: 'S',
    Boss: 'A',
    PVP: 'SS',
    Rarity: 'SSR',
    Burst_Type: 'I',
    Class: 'Supporter',
    Element: 'Iron',
    Weapon: 'RL',
    Manufacturer: 'Pilgrim',
    New: 'No',
    Limited: 'No',
    Investment: 'No',
    Treasure: 'No',
    ID: 97,
    Slug: 'rapunzel'
  },
  {
    Name: 'Rapunzel: Pure Grace',
    Story_LD: 'B',
    Story_HD: 'B',
    Boss: 'C',
    PVP: 'D',
    Rarity: 'SSR',
    Burst_Type: 'I',
    Class: 'Supporter',
    Element: 'Iron',
    Weapon: 'SR',
    Manufacturer: 'Pilgrim',
    New: 'No',
    Limited: 'No',
    Investment: 'No',
    Treasure: 'No',
    ID: 145,
    Slug: 'rapunzel-pure-grace'
  },
  {
    Name: 'Red Hood',
    Story_LD: 'SSS',
    Story_HD: 'SSS',
    Boss: 'SS',
    PVP: 'S',
    Rarity: 'SSR',
    Burst_Type: 'III',
    Class: 'Attacker',
    Element: 'Iron',
    Weapon: 'SR',
    Manufacturer: 'Pilgrim',
    New: 'No',
    Limited: 'No',
    Investment: 'No',
    Treasure: 'No',
    ID: 100,
    Slug: 'red-hood'
  },
  {
    Name: 'Red Hood',
    Story_LD: 'D',
    Story_HD: 'E',
    Boss: 'D',
    PVP: 'C',
    Rarity: 'SSR',
    Burst_Type: 'II',
    Class: 'Attacker',
    Element: 'Iron',
    Weapon: 'SR',
    Manufacturer: 'Pilgrim',
    New: 'No',
    Limited: 'No',
    Investment: 'No',
    Treasure: 'No',
    ID: 99,
    Slug: 'red-hood'
  },
  {
    Name: 'Red Hood',
    Story_LD: 'SSS',
    Story_HD: 'SSS',
    Boss: 'S',
    PVP: 'S',
    Rarity: 'SSR',
    Burst_Type: 'I',
    Class: 'Attacker',
    Element: 'Iron',
    Weapon: 'SR',
    Manufacturer: 'Pilgrim',
    New: 'No',
    Limited: 'No',
    Investment: 'No',
    Treasure: 'No',
    ID: 98,
    Slug: 'red-hood'
  },
  {
    Name: 'Rei',
    Story_LD: 'E',
    Story_HD: 'E',
    Boss: 'E',
    PVP: 'D',
    Rarity: 'SSR',
    Burst_Type: 'I',
    Class: 'Defender',
    Element: 'Water',
    Weapon: 'SMG',
    Manufacturer: 'Tetra',
    New: 'No',
    Limited: 'Yes',
    Investment: 'No',
    Treasure: 'No',
    ID: 101,
    Slug: 'rei'
  },
  {
    Name: 'Rei Ayanami',
    Story_LD: 'S',
    Story_HD: 'S',
    Boss: 'S',
    PVP: 'A',
    Rarity: 'SSR',
    Burst_Type: 'III',
    Class: 'Attacker',
    Element: 'Fire',
    Weapon: 'MG',
    Manufacturer: 'Abnormal',
    New: 'No',
    Limited: 'Yes',
    Investment: 'No',
    Treasure: 'No',
    ID: 136,
    Slug: 'rei-ayanami'
  },
  {
    Name: 'Rem',
    Story_LD: 'A',
    Story_HD: 'B',
    Boss: 'A',
    PVP: 'E',
    Rarity: 'SSR',
    Burst_Type: 'II',
    Class: 'Supporter',
    Element: 'Water',
    Weapon: 'MG',
    Manufacturer: 'Abnormal',
    New: 'No',
    Limited: 'Yes',
    Investment: 'Yes',
    Treasure: 'No',
    ID: 102,
    Slug: 'rem'
  },
  {
    Name: 'Rosanna',
    Story_LD: 'E',
    Story_HD: 'E',
    Boss: 'E',
    PVP: 'SS',
    Rarity: 'SSR',
    Burst_Type: 'I',
    Class: 'Attacker',
    Element: 'Electric',
    Weapon: 'MG',
    Manufacturer: 'Tetra',
    New: 'No',
    Limited: 'No',
    Investment: 'No',
    Treasure: 'No',
    ID: 103,
    Slug: 'rosanna'
  },
  {
    Name: 'Rosanna: Chic Ocean',
    Story_LD: 'S',
    Story_HD: 'A',
    Boss: 'S',
    PVP: 'C',
    Rarity: 'SSR',
    Burst_Type: 'II',
    Class: 'Supporter',
    Element: 'Wind',
    Weapon: 'AR',
    Manufacturer: 'Tetra',
    New: 'No',
    Limited: 'Yes',
    Investment: 'No',
    Treasure: 'No',
    ID: 131,
    Slug: 'rosanna-chic-ocean'
  },
  {
    Name: 'Rouge',
    Story_LD: 'SS',
    Story_HD: 'SS',
    Boss: 'SSS',
    PVP: 'D',
    Rarity: 'SSR',
    Burst_Type: 'I',
    Class: 'Supporter',
    Element: 'Electric',
    Weapon: 'SR',
    Manufacturer: 'Tetra',
    New: 'No',
    Limited: 'No',
    Investment: 'No',
    Treasure: 'No',
    ID: 139,
    Slug: 'rouge'
  },
  {
    Name: 'Rumani',
    Story_LD: 'B',
    Story_HD: 'B',
    Boss: 'C',
    PVP: 'SS',
    Rarity: 'SSR',
    Burst_Type: 'I',
    Class: 'Defender',
    Element: 'Fire',
    Weapon: 'RL',
    Manufacturer: 'Tetra',
    New: 'No',
    Limited: 'No',
    Investment: 'No',
    Treasure: 'No',
    ID: 142,
    Slug: 'rumani'
  },
  {
    Name: 'Rupee',
    Story_LD: 'B',
    Story_HD: 'C',
    Boss: 'C',
    PVP: 'E',
    Rarity: 'SSR',
    Burst_Type: 'II',
    Class: 'Attacker',
    Element: 'Iron',
    Weapon: 'AR',
    Manufacturer: 'Tetra',
    New: 'No',
    Limited: 'No',
    Investment: 'No',
    Treasure: 'No',
    ID: 104,
    Slug: 'rupee'
  },
  {
    Name: 'Rupee: Winter Shopper',
    Story_LD: 'C',
    Story_HD: 'C',
    Boss: 'D',
    PVP: 'D',
    Rarity: 'SSR',
    Burst_Type: 'I',
    Class: 'Defender',
    Element: 'Electric',
    Weapon: 'AR',
    Manufacturer: 'Tetra',
    New: 'No',
    Limited: 'Yes',
    Investment: 'No',
    Treasure: 'No',
    ID: 105,
    Slug: 'winter-shopper-rupee'
  },
  {
    Name: 'Sakura',
    Story_LD: 'A',
    Story_HD: 'A',
    Boss: 'A',
    PVP: 'C',
    Rarity: 'SSR',
    Burst_Type: 'I',
    Class: 'Supporter',
    Element: 'Fire',
    Weapon: 'SR',
    Manufacturer: 'Tetra',
    New: 'No',
    Limited: 'No',
    Investment: 'No',
    Treasure: 'No',
    ID: 106,
    Slug: 'sakura'
  },
  {
    Name: 'Sakura: Bloom in Summer',
    Story_LD: 'C',
    Story_HD: 'C',
    Boss: 'S',
    PVP: 'A',
    Rarity: 'SSR',
    Burst_Type: 'III',
    Class: 'Attacker',
    Element: 'Wind',
    Weapon: 'AR',
    Manufacturer: 'Tetra',
    New: 'No',
    Limited: 'Yes',
    Investment: 'No',
    Treasure: 'No',
    ID: 130,
    Slug: 'sakura-bloom-in-summer'
  },
  {
    Name: 'Scarlet',
    Story_LD: 'SS',
    Story_HD: 'S',
    Boss: 'S',
    PVP: 'SSS',
    Rarity: 'SSR',
    Burst_Type: 'III',
    Class: 'Attacker',
    Element: 'Electric',
    Weapon: 'AR',
    Manufacturer: 'Pilgrim',
    New: 'No',
    Limited: 'No',
    Investment: 'No',
    Treasure: 'No',
    ID: 107,
    Slug: 'scarlet'
  },
  {
    Name: 'Scarlet: Black Shadow',
    Story_LD: 'SSS',
    Story_HD: 'SS',
    Boss: 'SSS',
    PVP: 'S',
    Rarity: 'SSR',
    Burst_Type: 'III',
    Class: 'Attacker',
    Element: 'Wind',
    Weapon: 'RL',
    Manufacturer: 'Pilgrim',
    New: 'No',
    Limited: 'No',
    Investment: 'No',
    Treasure: 'No',
    ID: 108,
    Slug: 'scarlet-black-shadow'
  },
  {
    Name: 'Signal',
    Story_LD: 'E',
    Story_HD: 'E',
    Boss: 'E',
    PVP: 'E',
    Rarity: 'SSR',
    Burst_Type: 'II',
    Class: 'Attacker',
    Element: 'Fire',
    Weapon: 'SMG',
    Manufacturer: 'Elysion',
    New: 'No',
    Limited: 'No',
    Investment: 'No',
    Treasure: 'No',
    ID: 109,
    Slug: 'signal'
  },
  {
    Name: 'Sin',
    Story_LD: 'D',
    Story_HD: 'E',
    Boss: 'D',
    PVP: 'D',
    Rarity: 'SSR',
    Burst_Type: 'II',
    Class: 'Defender',
    Element: 'Electric',
    Weapon: 'AR',
    Manufacturer: 'Missilis',
    New: 'No',
    Limited: 'No',
    Investment: 'No',
    Treasure: 'No',
    ID: 110,
    Slug: 'sin'
  },
  {
    Name: 'Snow White',
    Story_LD: 'A',
    Story_HD: 'A',
    Boss: 'S',
    PVP: 'C',
    Rarity: 'SSR',
    Burst_Type: 'III',
    Class: 'Attacker',
    Element: 'Iron',
    Weapon: 'AR',
    Manufacturer: 'Pilgrim',
    New: 'No',
    Limited: 'No',
    Investment: 'Yes',
    Treasure: 'No',
    ID: 111,
    Slug: 'snow-white'
  },
  {
    Name: 'Snow White: Innocent Days',
    Story_LD: 'B',
    Story_HD: 'B',
    Boss: 'B',
    PVP: 'E',
    Rarity: 'SSR',
    Burst_Type: 'III',
    Class: 'Attacker',
    Element: 'Iron',
    Weapon: 'AR',
    Manufacturer: 'Pilgrim',
    New: 'No',
    Limited: 'Yes',
    Investment: 'No',
    Treasure: 'No',
    ID: 112,
    Slug: 'innocent-dayss-snow-white'
  },
  {
    Name: 'Soda',
    Story_LD: 'C',
    Story_HD: 'C',
    Boss: 'D',
    PVP: 'B',
    Rarity: 'SSR',
    Burst_Type: 'I',
    Class: 'Supporter',
    Element: 'Fire',
    Weapon: 'MG',
    Manufacturer: 'Tetra',
    New: 'No',
    Limited: 'No',
    Investment: 'No',
    Treasure: 'No',
    ID: 113,
    Slug: 'soda'
  },
  {
    Name: 'Soda: Twinkling Bunny',
    Story_LD: 'A',
    Story_HD: 'A',
    Boss: 'SS',
    PVP: 'A',
    Rarity: 'SSR',
    Burst_Type: 'III',
    Class: 'Attacker',
    Element: 'Iron',
    Weapon: 'SG',
    Manufacturer: 'Tetra',
    New: 'No',
    Limited: 'No',
    Investment: 'No',
    Treasure: 'No',
    ID: 114,
    Slug: 'soda-twinkling-bunny'
  },
  {
    Name: 'Soldier EG',
    Story_LD: 'F',
    Story_HD: 'F',
    Boss: 'F',
    PVP: 'F',
    Rarity: 'R',
    Burst_Type: 'III',
    Class: 'Attacker',
    Element: 'Electric',
    Weapon: 'AR',
    Manufacturer: 'Elysion',
    New: 'No',
    Limited: 'No',
    Investment: 'No',
    Treasure: 'No',
    ID: 115,
    Slug: 'soldier-eg'
  },
  {
    Name: 'Soldier FA',
    Story_LD: 'F',
    Story_HD: 'F',
    Boss: 'F',
    PVP: 'F',
    Rarity: 'R',
    Burst_Type: 'II',
    Class: 'Defender',
    Element: 'Iron',
    Weapon: 'SG',
    Manufacturer: 'Elysion',
    New: 'No',
    Limited: 'No',
    Investment: 'No',
    Treasure: 'No',
    ID: 116,
    Slug: 'soldier-fa'
  },
  {
    Name: 'Soldier OW',
    Story_LD: 'F',
    Story_HD: 'F',
    Boss: 'F',
    PVP: 'F',
    Rarity: 'R',
    Burst_Type: 'I',
    Class: 'Supporter',
    Element: 'Fire',
    Weapon: 'SMG',
    Manufacturer: 'Elysion',
    New: 'No',
    Limited: 'No',
    Investment: 'No',
    Treasure: 'No',
    ID: 117,
    Slug: 'soldier-ow'
  },
  {
    Name: 'Soline',
    Story_LD: 'C',
    Story_HD: 'D',
    Boss: 'B',
    PVP: 'D',
    Rarity: 'SSR',
    Burst_Type: 'III',
    Class: 'Attacker',
    Element: 'Iron',
    Weapon: 'SMG',
    Manufacturer: 'Elysion',
    New: 'No',
    Limited: 'No',
    Investment: 'No',
    Treasure: 'No',
    ID: 118,
    Slug: 'soline'
  },
  {
    Name: 'Sugar',
    Story_LD: 'C',
    Story_HD: 'D',
    Boss: 'B',
    PVP: 'A',
    Rarity: 'SSR',
    Burst_Type: 'III',
    Class: 'Attacker',
    Element: 'Iron',
    Weapon: 'SG',
    Manufacturer: 'Tetra',
    New: 'No',
    Limited: 'No',
    Investment: 'No',
    Treasure: 'No',
    ID: 119,
    Slug: 'sugar'
  },
  {
    Name: 'Tia',
    Story_LD: 'SS',
    Story_HD: 'S',
    Boss: 'SS',
    PVP: 'C',
    Rarity: 'SSR',
    Burst_Type: 'I',
    Class: 'Defender',
    Element: 'Iron',
    Weapon: 'RL',
    Manufacturer: 'Missilis',
    New: 'No',
    Limited: 'No',
    Investment: 'No',
    Treasure: 'No',
    ID: 120,
    Slug: 'tia'
  },
  {
    Name: 'Tove',
    Story_LD: 'B',
    Story_HD: 'B',
    Boss: 'SS',
    PVP: 'D',
    Rarity: 'SSR',
    Burst_Type: 'I',
    Class: 'Supporter',
    Element: 'Water',
    Weapon: 'AR',
    Manufacturer: 'Missilis',
    New: 'No',
    Limited: 'No',
    Investment: 'No',
    Treasure: 'No',
    ID: 121,
    Slug: 'tove'
  },
  {
    Name: 'Trony',
    Story_LD: 'D',
    Story_HD: 'D',
    Boss: 'B',
    PVP: 'E',
    Rarity: 'SSR',
    Burst_Type: 'III',
    Class: 'Attacker',
    Element: 'Fire',
    Weapon: 'SR',
    Manufacturer: 'Missilis',
    New: 'No',
    Limited: 'No',
    Investment: 'No',
    Treasure: 'No',
    ID: 122,
    Slug: 'trony'
  },
  {
    Name: 'Vesti',
    Story_LD: 'D',
    Story_HD: 'D',
    Boss: 'D',
    PVP: 'C',
    Rarity: 'SSR',
    Burst_Type: 'III',
    Class: 'Attacker',
    Element: 'Water',
    Weapon: 'RL',
    Manufacturer: 'Elysion',
    New: 'No',
    Limited: 'No',
    Investment: 'No',
    Treasure: 'No',
    ID: 123,
    Slug: 'vesti'
  },
  {
    Name: 'Viper (Treasure)',
    Story_LD: 'C',
    Story_HD: 'C',
    Boss: 'S',
    PVP: 'A',
    Rarity: 'SSR',
    Burst_Type: 'II',
    Class: 'Attacker',
    Element: 'Water',
    Weapon: 'SG',
    Manufacturer: 'Tetra',
    New: 'No',
    Limited: 'No',
    Investment: 'No',
    Treasure: 'Yes',
    ID: 134,
    Slug: 'viper-treasure'
  },
  {
    Name: 'Viper',
    Story_LD: 'D',
    Story_HD: 'D',
    Boss: 'C',
    PVP: 'A',
    Rarity: 'SSR',
    Burst_Type: 'II',
    Class: 'Attacker',
    Element: 'Water',
    Weapon: 'SG',
    Manufacturer: 'Tetra',
    New: 'No',
    Limited: 'No',
    Investment: 'No',
    Treasure: 'No',
    ID: 124,
    Slug: 'viper'
  },
  {
    Name: 'Volume',
    Story_LD: 'S',
    Story_HD: 'A',
    Boss: 'S',
    PVP: 'E',
    Rarity: 'SSR',
    Burst_Type: 'I',
    Class: 'Attacker',
    Element: 'Wind',
    Weapon: 'SMG',
    Manufacturer: 'Tetra',
    New: 'No',
    Limited: 'No',
    Investment: 'No',
    Treasure: 'No',
    ID: 125,
    Slug: 'volume'
  },
  {
    Name: 'Yan',
    Story_LD: 'D',
    Story_HD: 'D',
    Boss: 'D',
    PVP: 'D',
    Rarity: 'SSR',
    Burst_Type: 'I',
    Class: 'Supporter',
    Element: 'Fire',
    Weapon: 'RL',
    Manufacturer: 'Tetra',
    New: 'No',
    Limited: 'No',
    Investment: 'No',
    Treasure: 'No',
    ID: 126,
    Slug: 'yan'
  },
  {
    Name: 'Yulha',
    Story_LD: 'D',
    Story_HD: 'E',
    Boss: 'A',
    PVP: 'D',
    Rarity: 'SSR',
    Burst_Type: 'III',
    Class: 'Attacker',
    Element: 'Fire',
    Weapon: 'SR',
    Manufacturer: 'Tetra',
    New: 'No',
    Limited: 'No',
    Investment: 'No',
    Treasure: 'No',
    ID: 127,
    Slug: 'yulha'
  },
  {
    Name: 'Yuni',
    Story_LD: 'D',
    Story_HD: 'D',
    Boss: 'E',
    PVP: 'D',
    Rarity: 'SSR',
    Burst_Type: 'II',
    Class: 'Defender',
    Element: 'Fire',
    Weapon: 'RL',
    Manufacturer: 'Missilis',
    New: 'No',
    Limited: 'No',
    Investment: 'No',
    Treasure: 'No',
    ID: 128,
    Slug: 'yuni'
  },
  {
    Name: 'Zwei',
    Story_LD: 'B',
    Story_HD: 'B',
    Boss: 'B',
    PVP: 'B',
    Rarity: 'SSR',
    Burst_Type: 'I',
    Class: 'Supporter',
    Element: 'Electric',
    Weapon: 'SG',
    Manufacturer: 'Elysion',
    New: 'No',
    Limited: 'No',
    Investment: 'No',
    Treasure: 'No',
    ID: 133,
    Slug: 'zwei'
  },
  {
    Name: 'Asuka Shikinami Langley: Wille',
    Story_LD: 'SS',
    Story_HD: 'S',
    Boss: 'SSS',
    PVP: 'E',
    Rarity: 'SSR',
    Burst_Type: 'III',
    Class: 'Attacker',
    Element: 'Wind',
    Weapon: 'MG',
    Manufacturer: 'Abnormal',
    New: 'No',
    Limited: 'Yes',
    Investment: 'No',
    Treasure: 'No',
    ID: 155,
    Slug: 'asuka-shikinami-langley-wille'
  },
  {
    Name: 'Rei Ayanami (Tentative Name)',
    Story_LD: 'S',
    Story_HD: 'S',
    Boss: 'S',
    PVP: 'S',
    Rarity: 'SSR',
    Burst_Type: 'III',
    Class: 'Attacker',
    Element: 'Wind',
    Weapon: 'AR',
    Manufacturer: 'Abnormal',
    New: 'No',
    Limited: 'Yes',
    Investment: 'No',
    Treasure: 'No',
    ID: 156,
    Slug: 'rei-ayanami-tentative-name'
  },
  {
    Name: 'Sakura Suzuhara',
    Story_LD: 'C',
    Story_HD: 'C',
    Boss: 'C',
    PVP: 'E',
    Rarity: 'SR',
    Burst_Type: 'I',
    Class: 'Supporter',
    Element: 'Water',
    Weapon: 'SMG',
    Manufacturer: 'Abnormal',
    New: 'No',
    Limited: 'Yes',
    Investment: 'No',
    Treasure: 'No',
    ID: 157,
    Slug: 'sakura-suzuhara'
  },
  {
    Name: 'Trina',
    Story_LD: 'S',
    Story_HD: 'A',
    Boss: 'S',
    PVP: 'SS',
    Rarity: 'SSR',
    Burst_Type: 'II',
    Class: 'Supporter',
    Element: 'Electric',
    Weapon: 'RL',
    Manufacturer: 'Missilis',
    New: 'No',
    Limited: 'No',
    Investment: 'No',
    Treasure: 'No',
    ID: 158,
    Slug: 'trina'
  },
  {
    Name: 'Bready',
    Story_LD: 'B',
    Story_HD: 'B',
    Boss: 'S',
    PVP: 'E',
    Rarity: 'SSR',
    Burst_Type: 'III',
    Class: 'Attacker',
    Element: 'Water',
    Weapon: 'SR',
    Manufacturer: 'Tetra',
    New: 'Mo',
    Limited: 'No',
    Investment: 'No',
    Treasure: 'No',
    ID: 161,
    Slug: 'bready'
  },
  {
    Name: 'Drake (Treasure)',
    Story_LD: 'B',
    Story_HD: 'B',
    Boss: 'SS',
    PVP: 'S',
    Rarity: 'SSR',
    Burst_Type: 'III',
    Class: 'Attacker',
    Element: 'Fire',
    Weapon: 'SG',
    Manufacturer: 'Missilis',
    New: 'No',
    Limited: 'No',
    Investment: 'No',
    Treasure: 'Yes',
    ID: 162,
    Slug: 'drake-treasure'
  },
  {
    Name: 'Crust',
    Story_LD: 'A',
    Story_HD: 'A',
    Boss: 'A',
    PVP: 'C',
    Rarity: 'SSR',
    Burst_Type: 'II',
    Class: 'Supporter',
    Element: 'Water',
    Weapon: 'RL',
    Manufacturer: 'Tetra',
    New: 'No',
    Limited: 'No',
    Investment: 'No',
    Treasure: 'No',
    ID: 163,
    Slug: 'crust'
  },
  {
    Name: 'Siren',
    Story_LD: 'SSS',
    Story_HD: 'SSS',
    Boss: 'SSS',
    PVP: 'S',
    Rarity: 'SSR',
    Burst_Type: 'I',
    Class: 'Supporter',
    Element: 'Wind',
    Weapon: 'SMG',
    Manufacturer: 'Pilgrim',
    New: 'Yes',
    Limited: 'No',
    Investment: 'No',
    Treasure: 'No',
    ID: 164,
    Slug: 'siren'
  },
  {
    Name: 'Mihara: Bonding Chain',
    Story_LD: 'B',
    Story_HD: 'C',
    Boss: 'SSS',
    PVP: 'A',
    Rarity: 'SSR',
    Burst_Type: 'III',
    Class: 'Attacker',
    Element: 'Fire',
    Weapon: 'MG',
    Manufacturer: 'Missilis',
    New: 'Yes',
    Limited: 'No',
    Investment: 'No',
    Treasure: 'No',
    ID: 165,
    Slug: 'mihara-bonding-chain'
  }
];
